import classNames from 'classnames';

import flywireFeiHui from './flywireFeiHui.svg';

import './ChineseLogo.scss';

const DEFAULT_SIZE = 'medium';

type ChineseLogoProps = {
  size?: string;
  className?: string;
};

const ChineseLogo = ({ size = DEFAULT_SIZE, className }: ChineseLogoProps) => {
  const logoSizeClass = `ChineseLogo--${size}`;
  const logoClassName = classNames(
    'ChineseLogo',
    { [logoSizeClass]: !!size },
    className,
  );

  return (
    <img
      className={logoClassName}
      src={flywireFeiHui}
      alt="Flywire Fei Hui"
      fetchpriority="high"
      loading="eager"
    />
  );
};

export { ChineseLogo };
